import React, { Component } from "react";

import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";

import LoginLayout from "./Layout";

import "./Login.css";

import { connect } from "react-redux";
import { authSendPassword } from "../app/actions";

class SendPassword extends Component {
  state = {
    login: ""
  };

  send = e => {
    e.preventDefault();
    this.props.send(this.state.login);
  };

  handleChange = e => {
    const target = e.target;
    this.setState(state => ({ [target.name]: target.value }));
  };

  render() {
    return (
      <LoginLayout>
        <form onSubmit={this.send}>
          <p className="message">Recevez un nouveau mot de passe par email.</p>
          <TextField
            name="login"
            value={this.state.login}
            onChange={this.handleChange}
            hintText="Saisir votre identifiant"
            floatingLabelText="Votre identifiant"
          />
          <div className="buttons">
            <RaisedButton type="submit" label="Renvoi" primary />
          </div>
        </form>
      </LoginLayout>
    );
  }
}

/************* Container part */

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  send: login => {
    dispatch(authSendPassword(login));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendPassword);



// WEBPACK FOOTER //
// ./src/login/SendPassword.js